import { AxiosResponse } from 'axios';
import { TenantSettingsService } from './tenantSettingsService';

export interface ApiTenantSettings {
    getTenantSettings(tenantId: string): Promise<AxiosResponse>;
    getDefaultFont(): Promise<AxiosResponse>;
    getCrmLookupConfigurations(): Promise<AxiosResponse>;
}

export const tenantSettingsService = new TenantSettingsService();